import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, ViewChild, forwardRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';
import { Calendar } from 'primeng/calendar';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';

const noop = () => {};

export const CUSTOM_FMTIMEPICKER_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormTimepickerV2Component),
  multi: true
};

@Component({
  selector: 'fm-time-v2',
  templateUrl: 'form-timepicker.component.html',
  styleUrls: ['form-timepicker.component.scss'],
	encapsulation: ViewEncapsulation.None,
  providers: [CUSTOM_FMTIMEPICKER_CONTROL_VALUE_ACCESSOR],
})
export class FormTimepickerV2Component extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) { super(); }

  @Input()defaultDate:Date;
  @Input() resetBtn: boolean = true;
  @Input() hourFormat: number = 12;
  @Input() stepMinute: number = 1;
  @Input() inline: boolean = false;
  @Input() displayIcon: boolean = true;
  @Input() public disabled: boolean = false;
  @Output() onSelectValue: EventEmitter<any> = new EventEmitter<any>();

  tabindex: string;
  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }
  @ViewChild('in') public input: ElementRef;
  @ViewChild(Calendar) calendar: Calendar;

  private innerValue: boolean;
  private isCalendarOverlayOpen: boolean = false;
  public isOnFocus: boolean = false;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));

    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
  }

  ngOnDestroy() {}

  @HostListener('keypress', ['$event'])
  handleSpace(event: KeyboardEvent) {
    if (event.charCode === 32) {
      const newVal = !this.value;
      this.writeValue(newVal);
      this.onChangeCallback(newVal);
    }
  }

  get value(): any {
    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  onClick(event: any) {
  }

  onFocus() {
    this.isCalendarOverlayOpen = true;
    this.isOnFocus = true;
  }

  //Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  onChange(obj: { originalEvent: Event; value: boolean }) {
    if (obj.value !== this.innerValue) {
      this.writeValue(obj.value);
      this.onChangeCallback(obj.value);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onSelect(event: Event) {
    this.writeValue(event);
    this.onChangeCallback(event);
    this.onSelectValue.emit(event);
  }

  onCancel() {
    this.isCalendarOverlayOpen = false;
    this.isOnFocus = false;
  }

  focusOut() {
    if (!this.isCalendarOverlayOpen) {
      this.isOnFocus = false;
    }
  }
}
